import {
  callApiPatch,
  callApiPost,
  constructApiUrl,
  createParams,
  validateParams,
  getChangedParams,
} from './common';
import { createInsuranceCheck, sendRecommendation } from '../../actions/Api';
import { createErrorBody } from '../error';

const type = 'recommend';

/**
 * Determines if the state allows us to run updates.
 * @param  {object} state The current state.
 * @return {boolean}      If we can update or not.
 */
const shouldUpdate = (state) => {
  return state.isUpdatingCustomer ? state.isUpdatingCustomer : true;
};


/**
 * Call the API using POST.
 * @param  {string} service The service to call.
 * @param  {Object} params  The params for the service.
 * @return {Promise}        The Promise.
 */
const callInsuranceCheckApiPost = (service, params, dispatch) => {
  const url = constructApiUrl(type, service, 'insurance_check');
  return callApiPost(url, params, dispatch);
};

/**
 * Call the API using POST.
 * @param  {string} service The service to call.
 * @param  {Object} params  The params for the service.
 * @return {Promise}        The Promise.
 */
const sendRecommendationApiPost = (service, params, dispatch) => {
  const url = constructApiUrl('send', service, 'insurance_check');
  return callApiPost(url, params, dispatch);
};

/**
 * Call the API using PATCH.
 * @param  {string} service The service to call.
 * @param  {Object} params  The params for the service.
 * @return {Promise}        The Promise.
 */
const callCustomerApiPatch = (service, params, dispatch) => {
  const url = constructApiUrl(type, service, 'insurance_check');
  return callApiPatch(url, params, dispatch);
};

/**
 * Dispatches the create action.
 * @param  {string} service The service to use.
 * @param  {Object} params The params to call the service with.
 * @return {function} Dispatch function.
 */
const callCreateInsuranceCheck = (service, params) => {
  return dispatch => {
    dispatch(createInsuranceCheck());
    return callInsuranceCheckApiPost(service, params, dispatch);
  };
};

/**
 * Call the create service.
 * @param  {array}  params     The params to call the service with.
 * @param  {Object} formValues Values from the form that might not yet be set in the state.
 * @return {Promise}           The promise of the service.
 */
export const requestCreateInsuranceCheck = (params, formValues) => {
  return (dispatch, getState) => {
    if (shouldUpdate(getState())) {
      const mappedParams = params ? createParams(params, formValues, getState()) : {};
      // Ensure that we have the correct parameters. Fail if not.
      const errors = params ? validateParams(mappedParams, params) : [];
      if (errors.length > 0) {
        return Promise.reject(createErrorBody('Missing parameters', errors));
      }
      const service = '';
      return dispatch(callCreateInsuranceCheck(service, mappedParams));
    }

    // Let the calling code know there's nothing to wait for.
    return Promise.resolve();
  };
};

/**
 * Dispatches the create action.
 * @param  {string} service The service to use.
 * @param  {Object} params The params to call the service with.
 * @return {function} Dispatch function.
 */
const callSendRecommendation = (service, params) => {
  return dispatch => {
    dispatch(sendRecommendation());
    return sendRecommendationApiPost(service, params, dispatch);
  };
};

/**
 * Call the create service.
 * @param  {array}  params     The params to call the service with.
 * @param  {Object} formValues Values from the form that might not yet be set in the state.
 * @return {Promise}           The promise of the service.
 */
export const requestSendRecommendation = (params, formValues) => {
  return (dispatch, getState) => {
    if (shouldUpdate(getState())) {
      const mappedParams = params ? createParams(params, formValues, getState()) : {};
      // We need to map the Url so customer service knows where its coming from.
      mappedParams.url = window.location.href;
      // Ensure that we have the correct parameters. Fail if not.
      const errors = params ? validateParams(mappedParams, params) : [];
      if (errors.length > 0) {
        return Promise.reject(createErrorBody('Missing parameters', errors));
      }
      const service = '';
      return dispatch(callSendRecommendation(service, mappedParams));
    }

    // Let the calling code know there's nothing to wait for.
    return Promise.resolve();
  };
};




// WEBPACK FOOTER //
// ./src/utilities/api/insuranceCheck.js